// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditPopup_deleteButton__caRdj","field":"EditPopup_field__WV1TH","text":"EditPopup_text__QOzPJ"};